import { pdf } from '@react-pdf/renderer';

/**
 * Generate a downloadable PDF from the pdfComponent and return a blob that can be used to display or download it.
 */
export async function generatePdfAsBlob(pdfComponent: any): Promise<Blob> {
    let blob = await pdf(pdfComponent).toBlob();
    return blob;
}
